// temporary workaround for expo 45 bug:
// https://github.com/expo/snack/pull/292
// fix: https://github.com/wcandillon/react-native-redash/issues/395#issuecomment-839586492
// eslint-disable-next-line no-underscore-dangle
global.__reanimatedWorkletInit = () => {}
// https://github.com/expo/expo/issues/17758
